import { DeleteIcon } from "@chakra-ui/icons";
import { Button, Spinner, useToast } from "@chakra-ui/react";
import { useIntl } from "react-intl";
import { useLocation } from "wouter";

import { BulkExportType } from "@nens/ldo/api-v1";

import { useBulkExportHook } from "./bulk-exports-hook";
import { getBulkExportListUrl } from "./routes";

export function DeleteExportButton({ exportType, id }: { exportType: BulkExportType; id: number }) {
  const intl = useIntl();
  const toast = useToast();
  const setLocation = useLocation()[1];

  const listUrl = getBulkExportListUrl(exportType);
  const { bulkExportResponse, actionAllowed, deleteExportMutation } = useBulkExportHook(
    exportType,
    id,
    { loadScenarios: false }
  );

  const disabled =
    !bulkExportResponse.isSuccess || !actionAllowed("delete") || !deleteExportMutation.isIdle;

  return (
    <Button
      title={intl.formatMessage({
        id: "export.delete_export",
        defaultMessage: "Delete export",
      })}
      isDisabled={disabled}
      variant="solid"
      colorScheme="red"
      leftIcon={deleteExportMutation.isPending ? <Spinner /> : <DeleteIcon />}
      onClick={() => {
        if (!disabled) {
          deleteExportMutation.mutate(undefined, {
            onSuccess: async () => {
              setLocation(listUrl);
              toast({
                title: "Deleted",
                description: `Bulk export #${id.toString()} deleted`,
                status: "success",
                duration: 5000,
                isClosable: true,
              });
            },
            onError: () => {
              toast({
                title: "Not deleted",
                description: "Could not delete export",
                status: "warning",
                duration: 5000,
                isClosable: true,
              });
            },
          });
        }
      }}
    >
      {intl.formatMessage({
        id: "export.delete_export",
        defaultMessage: "Delete export",
      })}
    </Button>
  );
}
